import axios from "axios";
const actions = {
  async getTransferClients({ commit }) {
    const res = await axios.get("/transfer/clients");
    commit("SET_ACCESSIBLE_CLIENTS", res.data.data);
    return res.data;
  },

  async transferEntities(_, payload) {
    const res = await axios.post("/transfer", payload);
    return res.data;
  },
};

export default actions;
